import React, { useEffect } from 'react';

import { useLocale } from 'state/intl';
import { useMParticleContext } from 'state/mParticle';

import { StyledExperience } from './experience';

const Experience = () => {
  const { language } = useLocale();
  const mParticle = useMParticleContext();
  const logEvent = mParticle.logEvent;

  useEffect(() => {
    const handleComms = (_args: MessageEvent) => {
      if (typeof _args.data === 'string') {
        const { type, evtSource, mParticleEvtType, evtMessage } = JSON.parse(_args.data);

        switch (type) {
          case 'MPARTICLE_LOG':
            logEvent(evtSource, mParticleEvtType, evtMessage);
            break;
          default:
            break;
        }
      }
    };

    window.addEventListener('message', handleComms);

    return () => {
      window.removeEventListener('message', handleComms);
    };
  }, [logEvent]);

  return (
    <StyledExperience
      title="timsforgood"
      src={`https://tims-for-good-prod.rbi.digital/?timsLang=${language}&isNative=false`}
      sandbox="allow-scripts allow-same-origin allow-modals"
    ></StyledExperience>
  );
};

export default Experience;
